<template>
  <page-view class="tms-data-board tms-style">
    <div slot="pageRight">
      <div class="data-statistics">
        <div style="display: flex;justify-content: space-between;">
            <div class="title" style="display: flex;padding-bottom: 16px;">
                <span style="color:#59b9d3">{{ $t('DomesticTransportation.DataStatistics') }}</span>
                <div style="width:2px;margin: 3px 8px;background-color: #9C9C9C;"></div>
                <span style="color:#9C9C9C;cursor:pointer" @click="goOrderSearch()">{{ $t('DomesticTransportation.OrderInquiry') }}</span>
            </div>
            <!-- <div class="scription-center" @click="showScription()"><i class="el-icon-collection" style="margin-right: 4px;"></i>订阅中心</div> -->
        </div>

        <div class="sieved">
          <div class="flex" style="padding:0px 4px;">
                <div>{{ startDate + " ~ " + endDate }}</div>
                <div class="line-between"></div>
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                    {{ dateActive }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="item in dateSelect"
                        :key="item"
                        :command="item"
                    >{{ item }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            <!-- <a-radio-group
              class="time-select"
              v-model="timeDimension"
              @change="timeDimensionChange"
            >
              <a-radio-button value="Month">当月度</a-radio-button>
              <a-radio-button value="Quarter">当季度</a-radio-button>
              <a-radio-button value="Year">当年度</a-radio-button>
            </a-radio-group> -->
          </div>
          <div style="text-align: right;">
            <div class="circuit">
              <p>{{ $t('DomesticTransportation.RouteFiltering') }}</p>
              <el-select
                v-model="circuitSelect"
                style="width: 180px; margin-left: 10px; border-radius: 8px;border: none;"
                size="small"
                :popper-append-to-body="false"
                @change="handleChange"
              >
                <el-option v-for="(item,index) in routeList" :key="index" :value="item.RouteName" :label="item.label || item.RouteName"> {{ item.label || item.RouteName }} </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div
          class="data-item"
          v-loading="fullscreenLoading"
          :element-loading-text="$t('DomesticTransportation.loadingStatus')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(196,196,204, 0.1)"
        >
          <!-- <div class="data-item-left"> -->
            <!-- <div class="accumulated" style="background: #ebf6ff">
              <div>
                <p class="accumulated-label">累计金额（万元）</p>
                <div class="accumulated-content">
                  {{ basicData.BasicData_TotalAmount }}
                </div>
              </div>
              <img src="@/assets/tms/accumulated_money.png" />
            </div> -->
            <!-- <div class="accumulated" style="background: #ebfdee">
              <div>
                <p class="accumulated-label">累计车次（次）</p>
                <div class="accumulated-content">
                  {{ basicData.BasicData_TotalDispatch }}
                </div>
              </div>
              <img src="@/assets/tms/accumulated_train_number.png" />
            </div>
            <div class="accumulated" style="background: #ffefef">
              <div>
                <p class="accumulated-label">累计里程（万公里）</p>
                <div class="accumulated-content">
                  {{ basicData.BasicData_TotalMileage }}
                </div>
              </div>
              <img src="@/assets/tms/accumulated_mileage.png" />
            </div> -->
          <!-- </div> -->
          <div class="data-item-right">
            <!-- <div class="waybill-quantity">
              <img src="@/assets/tms/waybill_number.png" />
              <div class="waybill-quantity-content">
                {{ basicData.BasicData_Task_Total }}
              </div>
              <div class="waybill-quantity-label">全部运单数量</div>
            </div> -->
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('全部')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.TotalOrderVolume') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/transport_status_1.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_Total }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('待提货')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.AwaitingPickup') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/will_pick_goods.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_DTH }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('已提货')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.PickedUp') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/pick_goods_finish.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_YTH }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('运输中')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.InTransit') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/transport_status_2.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_YSZ }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="background: #ebfdee;display: flex;justify-content: space-between;align-items: flex-end;">
              <div>
                <div class="status-quantity-label">{{ $t('DomesticTransportation.PickupOntimeRate') }}</div>
                <div class="flex" style="align-items: center; margin-top: 14px">
                    <div class="status-quantity-content" style="margin-left: 0;">
                        {{ basicData.BasicData_Task_THZSL }}
                    </div>
                </div>
              </div>
              <img src="@/assets/tms/accumulated_train_number.png" style="width: 50px;height: 50px;" />
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('派送中')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.OutforDelivery') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/delivery.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_PSZ }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('已签收')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.Signedfor') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/transport_status_3.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_YQS }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('提货延误')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.PickupDelayed') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/delay.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_THYW }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="cursor: pointer;" @click="goOrderSearch('送货延误')">
              <div class="status-quantity-label">{{ $t('DomesticTransportation.DeliveryDelayed') }}</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/delay.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_Task_SHYW }}
                </div>
              </div>
            </div>
            <div class="status-quantity" style="background: #ffefef;display: flex;justify-content: space-between;align-items: flex-end;">
              <div>
                <div class="status-quantity-label">{{ $t('DomesticTransportation.DeliveryOntimeRate') }}</div>
                <div class="flex" style="align-items: center; margin-top: 14px">
                    <div class="status-quantity-content" style="margin-left: 0;">
                        {{ basicData.BasicData_Task_SHZSL }}
                    </div>
                </div>
              </div>
              <img src="@/assets/tms/accumulated_mileage.png" style="width: 50px;height: 50px;" />
            </div>
            <!-- <div class="status-quantity">
              <div class="status-quantity-label">已结算数量</div>
              <div class="flex" style="align-items: center; margin-top: 14px">
                <img src="@/assets/tms/transport_status_4.png" />
                <div class="status-quantity-content">
                  {{ basicData.BasicData_YJS }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="mileage-train-number">
        <div class="mileage-statistics">
          <div class="title" style="display: flex;justify-content: space-between;">
            <div>
                <span>{{ $t('DomesticTransportation.MonthlyMileageStatistics') }}</span>
                <el-tooltip effect="dark" :content="$t('DomesticTransportation.echartsTips')" placement="right" style="margin-left: 8px;">
                    <i class="el-icon-warning-outline"></i>
                </el-tooltip>
            </div>
            <div>
                <img v-if="showMileageEchart" src="@/assets/tms/watch.png" @click="requestShowpanel('hide','MonthlyMiles')" style="width: 20px;height: 20px;cursor: pointer;" />
                <img v-else src="@/assets/tms/close_watch.png" @click="requestShowpanel('show','MonthlyMiles')" style="width: 20px;height: 20px;cursor: pointer;" />
            </div>
          </div>
          <div class="mileage-statistics-date">
            <div class="mileage-statistics-desc">
              <div>{{ $t('DomesticTransportation.Mileage') }}</div>
            </div>
            <el-date-picker
              v-model="mileagePickerTime"
              type="month"
              :clearable="false"
              :placeholder="$t('DomesticTransportation.month')"
              size="small"
              style="width: 220px;"
              @change="mileageChange"
            >
            </el-date-picker>
          </div>
          <BarChart v-if="showMileageEchart" id="mileage" ref="mileage" />
        </div>
        <div class="mileage-statistics">
          <div class="title" style="display: flex;justify-content: space-between;">
            <div>
                <span>{{ $t('DomesticTransportation.MonthlyVehicleTripsCount') }}</span>
                <el-tooltip effect="dark" :content="$t('DomesticTransportation.echartsTips')" placement="right" style="margin-left: 8px;">
                    <i class="el-icon-warning-outline"></i>
                </el-tooltip>
            </div>
            <div>
                <img v-if="showVehicleEchart" src="@/assets/tms/watch.png" @click="requestShowpanel('hide','MonthlyDispatch')" style="width: 20px;height: 20px;cursor: pointer;" />
                <img v-else src="@/assets/tms/close_watch.png" @click="requestShowpanel('show','MonthlyDispatch')" style="width: 20px;height: 20px;cursor: pointer;" />
            </div>
        </div>
          <div class="mileage-statistics-date">
            <div class="train-number-desc">
              <div>{{ $t('DomesticTransportation.TotalNumberofTrips') }}</div>
            </div>
            <el-date-picker
              v-model="trainPickerTime"
              type="month"
              :clearable="false"
              :placeholder="$t('DomesticTransportation.month')"
              size="small"
              style="width: 220px;"
              @change="trainChange"
            >
            </el-date-picker>
          </div>
          <BarChart v-if="showVehicleEchart" id="trainNumber" ref="train" color="rgba(230,108,104,1)" />
        </div>
      </div>
      <!-- <div class="delivery-settlement">
        <div class="title">月均交付/结算/付款周期统计</div>
        <div class="flex" style="margin-top: 12px">
          <LineChart style="flex: 1" id="settlement" ref="settlement" />
          <div
            style="
              margin-top: 22px;
              display: inline-block;
              text-align: right;"
          >
            <el-date-picker
              v-model="yearPickerTime"
              type="year"
              :clearable="false"
              placeholder="年度"
              size="small"
              @change="yearChange"
            >
            </el-date-picker>
            <div class="stacked-line" style="margin-top: 26px; color: #2a77ec">
              <div
                class="circular-ring"
                style="border: 2px solid #2a77ec"
              ></div>
              月均付款周期天数
            </div>
            <div class="stacked-line" style="color: #00ce85">
              <div
                class="circular-ring"
                style="border: 2px solid #00ce85"
              ></div>
              月均结算周期天数
            </div>
            <div class="stacked-line" style="color: #e66c68">
              <div
                class="circular-ring"
                style="border: 2px solid #e66c68"
              ></div>
              月均交付周期天数
            </div>
          </div>
        </div>
      </div> -->
      <el-date-picker
        v-show="false"
        ref="timePick"
        popper-class="time-pick"
        v-model="daterange"
        type="daterange"
        size="mini"
        :start-placeholder="$t('DomesticTransportation.startDate')"
        :end-placeholder="$t('DomesticTransportation.endDate')"
        :picker-options="pickerOptions"
        @change="timePickChange"
      >
      </el-date-picker>
      <div class="foot-tip">
        <i class="el-icon-warning-outline"></i>
        {{ $t('DomesticTransportation.statement') }}
      </div>
      <ScriptCenter ref="scriptCenter" @success="$refs.SubscriptionSuccess.open()"/>
      <SubscriptionSuccess ref="SubscriptionSuccess" />
    </div>
  </page-view>
</template>
<script>
import i18n from '@/i18n/i18n'
import { PageView } from '@/components'
import BarChart from '@/components/barChart'
import LineChart from '@/components/lineChart'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import {
  getroutelist,
  getbasicdata,
  getmileagedata,
  getdispatchdata,
  showpanel
} from '@/api/tms'
import moment from 'moment'
export default {
  components: {
    PageView,
    BarChart,
    LineChart,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {
    return {
      moment,
      timeDimension: 'Month',
      basicData: {},
      circuitSelect: 'all',
      mileagePickerTime: moment(new Date()).format('YYYY-MM'),
      trainPickerTime: moment(new Date()).format('YYYY-MM'),
      yearPickerTime: moment(new Date()).format('YYYY'),
      routeList: [{ RouteName: 'all', label: i18n.t('DomesticTransportation.All') }],
      fullscreenLoading: false,
      dateActive: '',
      dateSelect: [
      i18n.t('DomesticTransportation.MonthlySummary'),
      i18n.t('DomesticTransportation.Last7Days'),
      i18n.t('DomesticTransportation.LastMonth'),
      i18n.t('DomesticTransportation.CustomInput')
      ],
      startDate: '',
      endDate: '',
      daterange: [],
      showMileageEchart: true,
      showVehicleEchart: true,
      selectData: '',
      pickerOptions: {
        // onPick：选中日期后会执行的回调。写成箭头函数否则this.selectData会报错
        // 点击时，选择的是初始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 第二次点击日期选择器，选好初始时间和结束时间后，解除禁用限制
            this.selectData = ''
          }
        },
        // 设置禁用状态，参数为当前日期，要求返回 Boolean。同理写成箭头函数
        disabledDate: (time) => {
          // 是否限制的判断条件，if里写点击了初始时间后的判断条件
          // 即第二个选择的时间前后不能超过初始时间的一个月
          if (this.selectData) {
            return time.getTime() > new Date() || time.getTime() > this.selectData + 30 * 24 * 3600 * 1000 || time.getTime() < this.selectData - 30 * 24 * 3600 * 1000;
            // time.getTime() > new Date() 为所选时间不能超过今日
            // 30 * 24 * 3600 * 1000则为一个月的毫秒数，根据自己的需求修改限制的时间范围
          } else {
            return time.getTime() > new Date();
            // 如果不需要限制所选时间不能超过今日，则直接return false即可
          }
        }
      },
      lang: 'zh'
    }
  },
  mounted() {
    this.lang = this.$ls.get('lang');
    this.handleCommand(i18n.t('DomesticTransportation.MonthlySummary'))
    this.getMile('first')
    this.getTrain('first')
    this.getRoutelist()
  },
  methods: {
    timeDimensionChange() {
      this.getData()
    },
    getData() {
      this.fullscreenLoading = true
      const params = {
        RouteName: this.circuitSelect,
        StartDt: this.startDate,
        EndDt: this.endDate
        // StatisticsDateType: this.timeDimension
      }
      getbasicdata(params).then((res) => {
        this.fullscreenLoading = false
        if (!res.Data) return
        this.basicData = res.Data
        this.showMileageEchart = this.basicData.IsShow_MonthlyMiles
        this.showVehicleEchart = this.basicData.IsShow_MonthlyDispatch
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    getRoutelist() {
      getroutelist().then(res => {
        if (!res.Data) return
        this.routeList = [{ RouteName: 'all', label: i18n.t('DomesticTransportation.All') }]
        this.routeList.push(...res.Data)
      })
    },
    getMile(type) {
      getmileagedata({
        Month: moment(this.mileagePickerTime).format('YYYY-MM')
      }).then((res) => {
        const mileData = res.Data.Data || []
        const itemList = mileData.map((item) => {
          return item.MileageData_RouteName
        })
        const dataList = mileData.map((item) => {
          return item.MileageData_Mileage
        })
        if (itemList && dataList && itemList.length && dataList.length) {
          this.$refs.mileage.chartInit(itemList, dataList)
        } else {
          this.$refs.mileage.chartInit([], [])
          if(type !== 'first'){
            this.$message.error(i18n.t('DomesticTransportation.monthNotData'))
          }
        }
      })
    },
    getTrain(type) {
      getdispatchdata({
        Month: moment(this.trainPickerTime).format('YYYY-MM')
      }).then((res) => {
        const trainData = res.Data.Data || []
        const itemList = trainData.map((item) => {
          return item.DispatchData_RouteName
        })
        const dataList = trainData.map((item) => {
          return item.DispatchData_Mileage
        })
        if (itemList && dataList && itemList.length && dataList.length) {
          this.$refs.train.chartInit(itemList, dataList)
        } else {
          this.$refs.train.chartInit([], [])
          if(type !== 'first'){
            this.$message.error(i18n.t('DomesticTransportation.monthNotData'))
          }
        }
      })
    },
    getLineChartData() {
    //   getcycledata({ Year: moment(this.yearPickerTime).format('YYYY') }).then(
    //     (res) => {
    //       if (!res.Data) return
    //       const DeliveryData = res.Data.DeliveryData.map((item) => {
    //         return item.CycleData_Days
    //       })
    //       const SettlementData = res.Data.SettlementData.map((item) => {
    //         return item.CycleData_Days
    //       })
    //       const PaymentData = res.Data.PaymentData.map((item) => {
    //         return item.CycleData_Days
    //       })
    //       this.$refs.settlement.chartInit(
    //         PaymentData,
    //         SettlementData,
    //         DeliveryData
    //       )
    //     }
    //   )
    },
    mileageChange() {
      this.getMile()
    },
    trainChange() {
      this.getTrain()
    },
    yearChange() {
      this.getLineChartData()
    },
    handleChange(e) {
      this.getData()
    },
    // 跳转订单查询
    goOrderSearch(status) {
      const _this = this
      this.$router.push({
        name: 'tmsOrder',
        query: {
          type: status || '',
          startDate: _this.startDate || '',
          endDate: _this.endDate || ''
        }
      })
    },
    timePickChange(e) {
      this.startDate = moment(e[0]).format('YYYY-MM-DD')
      this.endDate = moment(e[1]).format('YYYY-MM-DD')
      this.getData()
    },
    handleCommand(e) {
      this.dateActive = e || ''
      if (e === i18n.t('DomesticTransportation.CustomInput')) {
        this.daterange = []
        this.$refs.timePick.focus()
        return
      }
      this.endDate = moment(new Date()).format('YYYY-MM-DD')
      switch (e) {
        case i18n.t('DomesticTransportation.MonthlySummary'):
          this.startDate = moment(new Date()).startOf('month').format('YYYY-MM-DD')
          break
        case i18n.t('DomesticTransportation.Last7Days'):
          this.startDate = moment(new Date())
            .subtract(6, 'days')
            .format('YYYY-MM-DD')
          break
        case i18n.t('DomesticTransportation.LastMonth'):
          this.startDate = moment(new Date())
            .subtract(1, 'months')
            .format('YYYY-MM-DD')
          break
        // case '近三个月':
        //   this.startDate = moment(new Date())
        //     .subtract(3, 'months')
        //     .format('YYYY-MM-DD')
        //   break
        // case '近半年':
        //   this.startDate = moment(new Date())
        //     .subtract(6, 'months')
        //     .format('YYYY-MM-DD')
        //   break
        // case '近一年':
        //   this.startDate = moment(new Date())
        //     .subtract(1, 'years')
        //     .format('YYYY-MM-DD')
        //   break
      }
      this.getData()
    },
    requestShowpanel(val, type) {
      if (val === 'hide') {
        if (type === 'MonthlyMiles') {
          this.showMileageEchart = false
        } else {
          this.showVehicleEchart = false
        }
      } else {
        if (type === 'MonthlyMiles') {
          this.showMileageEchart = true
          this.getMile()
        } else {
          this.showVehicleEchart = true
          this.getTrain()
        }
      }
      showpanel({ ShowOrHide: val, ShowOrHideType: type }).then(res => {

      })
    },
    showScription() {
      this.$refs.scriptCenter.open('TMS')
    },
  }
}
</script>
<style lang="less">
.tms-data-board {
  padding: 10px;
  background: #f0f6fb;
  .plr25 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .ptb25 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .foot-tip {
    height: 36px;
    line-height: 36px;
    background-color: #F0F6FC;
    color: #8CA2BD;
    font-size: 12px;
    opacity: 0.85;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0px;
    padding-left: 208px;
  }
  .data-statistics {
    background: white;
    padding: 16px 20px;
    border-radius: 4px;
    .sieved {
      display: flex;
      justify-content: space-between;
      margin-top: 14px;
      align-items: center;
      .time-select {
        margin: 4px 0;
      }
      .circuit {
        display: flex;
        align-items: center;
      }
      .line-between {
        margin: 0 8px;
        width: 1px;
        height: 16px;
        background-color: #ccc;
      }
    }
    .line {
      margin: 20px 0;
      border: 0.5px solid #e9ecf2;
    }
    .data-item {
      display: flex;
      .data-item-left {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 45%);
        gap: 20px;
        .accumulated {
          display: flex;
          justify-content: space-between;
          padding: 16px 24px;
          height: 88px;
          .accumulated-label {
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
          .accumulated-content {
            font-size: 26px;
            font-weight: 600;
            color: #111827;
            margin-top: 12px;
            margin-bottom: 12px;
          }
          img {
            width: 64px;
            height: 64px;
            display: inline-block;
          }
        }
      }
      .data-item-right {
        width: 100%;
        display: grid;
        grid-template-columns:19% 19% 19% 19% 19%;
        gap: 16px;
        .waybill-quantity {
          border-radius: 10px;
          border: 1px solid #e9ecf2;
          grid-row-start: 1;
          grid-row-end: 3;
          padding-top: 46px;
          text-align: center;
          img {
            width: 40px;
            height: 40px;
            display: inline-block;
          }
          .waybill-quantity-content {
            font-size: 24px;
            margin-top: 10px;
            font-weight: 600;
            color: #111827;
          }
          .waybill-quantity-label {
            margin-top: 3px;
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
        }
        .status-quantity {
          padding: 14px 20px;
          border-radius: 10px;
          border: 1px solid #e9ecf2;
          img {
            width: 30px;
            height: 30px;
            display: inline-block;
          }
          .status-quantity-label {
            font-size: 12px;
            font-weight: 400;
            color: #4b5563;
          }
          .status-quantity-content {
            font-size: 24px;
            font-weight: 600;
            color: #111827;
            margin-left: 8px;
          }
        }
      }
    }
    .scription-center {
        border: 1px solid #53a2b6;
        color: #53a2b6;
        height: 30px;
        line-height: 18px;
        border-radius: 4px;
        padding:4px 16px;
        cursor: pointer;
    }
  }
  .mileage-train-number {
    height: 352px;
    margin-top: 10px;
    column-gap: 10px;
    display: flex;
    justify-content: space-between;
    .mileage-statistics {
      flex: 1;
      padding: 16px 20px;
      background: white;
      border-radius: 4px;
      .mileage-statistics-date {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;
        .mileage-statistics-desc {
          width: 108px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #e9ecf2;
          text-align: center;
          line-height: 26px;
          color: #58c6e4;
          div {
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              background: #58c6e4;
              border-radius: 50%;
              margin-right: 6px;
              margin-bottom: 2px;
            }
          }
        }
        .train-number-desc {
          width: 200px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid #e9ecf2;
          text-align: center;
          line-height: 26px;
          color: #e66c68;
          div {
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              background: #e66c68;
              border-radius: 50%;
              margin-right: 6px;
              margin-bottom: 2px;
            }
          }
        }
      }
    }
  }
  .delivery-settlement {
    background: white;
    width: 100%;
    height: 330px;
    padding: 16px 20px;
    border-radius: 4px;
    margin-top: 10px;
    .stacked-line {
      display: flex;
      width: 140px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #e9ecf2;
      text-align: center;
      line-height: 26px;
      margin-top: 14px;
      font-size: 12px;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
      margin-top: 9px;
      margin-left: 12px;
      margin-right: 6px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
  }
  .el-date-editor {
    .el-input__prefix {
      position: absolute;
      left: 180px; // left根据实际情况定值
      top: 0;
    }
    input {
      padding-left: 15px;
    }
  }
  // tabs样式
  .ant-radio-button-wrapper {
    background: #f6f6f8;
    border: none;
  }
  .ant-radio-button-wrapper-checked {
    background: white;
    box-shadow: 0 0 0 0 transparent !important;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }
  .el-range-editor.is-active,
  .el-range-editor.is-active:hover,
  .el-select .el-input__inner:focus,
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #59b9d3;
  }
  .el-select-dropdown__item.selected {
    color: #59b9d3 !important
  }
  .el-select-dropdown {
    z-index: 0;
    text-align: left;
  }
}
.time-pick {
    position: absolute;
    top: 160px !important;
    left: 220px !important;
    transform-origin: center top;
    z-index: 2003;
  }
</style>
